module.exports = __webpack_public_path__ + "img/bk_sign.1460b3dc.jpg";